$(".popup-opener a, a.popup-opener, button.popup-opener, a[href='#request-popup']").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("overflow-hidden");
    $("#request-popup").addClass("-open");
});
$(".request-popup .close-button").on("click", function (e) {
    $(this).closest(".request-popup").removeClass("-open");
    $("body").removeClass("overflow-hidden");
    $(".request-popup .wrapper").animate({
        scrollTop: 0
    }, 0);
});